import {
    AfterViewInit,
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {ActionFlag, FormItemComponentInterface, IFormDialogData} from '../../../../interface/component';
import {IFormItemsControls, IFormSavingData, IStep2, StepStructure} from '../../../../interface/form-structure';
import {IFieldShema} from '@usteknoloji/noosgrid';
import {GlobalObjectService} from '../../../../class/global-obj';
import * as _ from 'lodash';
import {HttpFormDataService} from '../../../../services/services';
import {IHttpSetting} from '../../../../interface/dataset-params';
import {FormComponent} from '../../../form/form.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'noos-view-stepper',
    templateUrl: './view-stepper.component.html',
    styleUrls: ['./view-stepper.component.scss']
})

@NoosFormTypeService.register('viewStep')
export class ViewStepperComponent implements OnInit, AfterViewInit, FormItemComponentInterface {


    prop: IFormItemsControls;
    isFilter = false;

    isForm = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    recordId = 0;

    formFieldStructure: IFieldShema[];
    formRecordData: any;
    pkeys: any;
    setting: IHttpSetting;


    @Input()
    steps: IStep2[] = [];

    stepStructures: StepStructure[] = [];

    @Input()
    processStepId = 0;

    currentProcessStepId = 0;


    @Output()
    selectingStep: EventEmitter<IStep2> = new EventEmitter<IStep2>();

    selectedStep: IStep2;
    currentStep: IStep2;
    enableSet = false;
    hiddenPanel = false;

    constructor(private httpService: HttpFormDataService, private dialog: MatDialog,
                private componentFactoryResolver: ComponentFactoryResolver, private noosFormTypeFactory: NoosFormTypeService,) {
        this.setting = GlobalObjectService.getVar('setting');
    }

    ngOnInit(): void {

        this.formFieldStructure = _.orderBy(GlobalObjectService.getVar('formFieldStructure_' + this.formId.toString()), ['list_order'], ['ASC']);
        this.formRecordData = GlobalObjectService.getVar('formRecordData_' + this.formId.toString());
        this.pkeys = GlobalObjectService.getVar('pkeys_' + this.formId.toString());
    }

    ngAfterViewInit(): void {
        if (this.prop.viewOptions !== undefined) {
            this.recordId = parseInt(GlobalObjectService.getVar('record_id_' + this.formId.toString()), 0);
            this.loadAppViewStepStructure(this.prop.viewOptions.appview_id);
            this.enableSet = this.prop.viewOptions.set_status;
        }
        this.hiddenPanel = this.steps.length === 0;
    }


    loadAppViewStepStructure(appViewId) {
        this.httpService.appViewStepInfo(this.setting, appViewId).subscribe(ret => {
            if (ret.complete) {
                this.stepStructures = ret.data;

                const fieldSearch = this.pkeys.filter(c => c.source_field === this.stepStructures[0].field_name);

                if (fieldSearch.length === 0) {
                    return;
                }
                const fieldName = fieldSearch[0].field_alias;
                const findData = this.formRecordData[fieldName];

                const findStep = this.stepStructures.filter(x => x.field_value === findData);
                if (findStep.length > 0) {
                    this.processStepId = findStep[0].step_id;
                    this.currentProcessStepId = findStep[0].step_id;
                    this.loadAppViewStep(this.prop.viewOptions.appview_id);
                }
            }
        });
    }

    loadAppViewStep(appViewId) {
        this.httpService.appViewDetail(this.setting, appViewId).subscribe(ret => {
            if (ret.complete) {
                this.steps = _.orderBy(ret.data.steps, ['list_order'], ['asc']);
                const sStep = this.steps.filter(x => x.id === this.processStepId);
                if (sStep.length > 0) {
                    this.selectedStep = sStep[0];
                    this.currentStep = sStep[0];
                }

            }
        });
    }

    onSelect(step: IStep2) {
        this.selectedStep = step;
        this.processStepId = step.id;
    }

    setStep() {

        if (this.selectedStep.list_order === this.currentStep.list_order) {
            return;
        }

        if (this.selectedStep.list_order < this.currentStep.list_order && !this.currentStep.step_is_goback) {
            alert('Seçilen adıma geri dönülemiyor!');
            return;
        }

        const actionStep: IStep2 = this.getActionStep();

        if (this.selectedStep.list_order > this.currentStep.list_order
            && this.currentStep.next_step_after_form_id !== null && this.currentStep.next_step_after_form_id !== undefined &&
            this.currentStep.next_step_after_form_id > 0) {
            // fsonraki bir adıma gidiyor ve form var
            const dialogData: IFormDialogData = {
                setting: this.setting,
                formId: this.selectedStep.next_step_after_form_id,
                formJson: null,
                actionFlag: ActionFlag.EDIT,
                API_URLS: null,
                workFlowObjectId: '',
                recordId: this.recordId
            };
            this.openStepForm(dialogData, this.selectedStep, actionStep,
                this.recordId,
                this.selectedStep.list_order > this.currentStep.list_order ? 'step_next' : 'step_back');
        } else {
            this.runStepUpdateSet(actionStep, this.recordId,
                this.selectedStep.list_order > this.currentStep.list_order ? 'step_next' : 'step_back');
        }

    }

    openStepForm(dialogData: IFormDialogData, step: IStep2, actionStep: IStep2, recordId: any, eventAction: string) {
        const dialogRef = this.dialog.open(FormComponent, {
            width: '400px',
            panelClass: 'formDialog',
            autoFocus: false,
            data: JSON.parse(JSON.stringify(dialogData))
        });

        dialogRef.afterClosed().subscribe((result: IFormSavingData) => {
            if (result) {
                this.runStepUpdateSet(actionStep, recordId, eventAction);
            }
        });
    }

    runStepUpdateSet(step: IStep2, recordId: any, eventAction: string) {

        let nextIdCR = false;
        let prevIdCR = false;

        this.httpService.coderunControlStep(this.setting, this.prop.viewOptions.appview_id, step.id).subscribe(ret => {
            if (ret.complete && ret.data !== null && ret.data.length > 0) {
                nextIdCR = ret.data.filter(x => x === 'step_next').length > 0;
                prevIdCR = ret.data.filter(x => x === 'step_back').length > 0;
            }
        });


        let updateSetId = 0;
        if (step.next_dataset_updateset_id !== null && step.next_dataset_updateset_id > 0 && eventAction === 'step_next') {
            updateSetId = step.next_dataset_updateset_id;
        } else if (step.prev_dataset_updateset_id !== null && step.prev_dataset_updateset_id > 0 && eventAction === 'step_back') {
            updateSetId = step.prev_dataset_updateset_id;
        }
        if (updateSetId > 0) {

            this.httpService.callStepUpdateSet(this.setting, this.prop.viewOptions.appview_id, recordId, updateSetId, step.id)
                .subscribe(ret => {

                    if (ret.complete) {
                        this.runStepCodeRun(nextIdCR || prevIdCR, step, recordId, eventAction);
                    } else {
                        alert('Geçiş işlemi tamamlanamadı.');
                    }

                });
        } else {
            this.runStepCodeRun(nextIdCR || prevIdCR, step, recordId, eventAction);
        }
    }

    runStepCodeRun(start: boolean, step: IStep2, recordId: number, eventAction: string) {

        if (start) {
            this.httpService.runCodeRunStep(this.setting, step.id, this.prop.viewOptions.appview_id, recordId, eventAction)
                .subscribe(ret => {
                    this.refresh(step);
                });
        } else {
            this.refresh(step);
        }
    }

    refresh(currentStep: IStep2) {
        this.processStepId = this.selectedStep.id;
        this.currentProcessStepId = this.selectedStep.id;
        this.currentStep = this.selectedStep;
    }


    getActionStep() {
        if (this.selectedStep.list_order > this.currentStep.list_order) {
            // next
            const thisStep = _.orderBy(this.steps.filter(x => x.list_order < this.selectedStep.list_order), ['list_order'], ['desc']);
            return thisStep[0];
        } else {
            const thisStep = _.orderBy(this.steps.filter(x => x.list_order > this.selectedStep.list_order), ['list_order'], ['asc']);
            return thisStep[0];
        }
    }

}
